import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../services/app.service';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './auth-layout.html',
    standalone: true,
    imports: [
        NgClass,
        RouterOutlet,
    ],
})
export class AuthLayout implements OnInit {
    store: any;
    showTopButton = false;
    headerClass = '';

    constructor(
        public storeData: Store<any>,
        private readonly service: AppService,
    ) {}

    ngOnInit() {
        this.initStore();
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                this.showTopButton = true;
            } else {
                this.showTopButton = false;
            }
        });
    }


    ngOnDestroy() {
        window.removeEventListener('scroll', () => {});
    }

    initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
